import Link from "next/link";
import { useRouter } from "next/router";

export default function RetainQueryLink({ href, ...props }) {
  const router = useRouter();
  const currentPath = router.pathname;
  const targetPath = typeof href === "object" ? href.pathname : href;

  // Destructure and exclude known dynamic and irrelevant query parameters
  const {
    category,
    subcategory,
    id,
    product,
    page,
    slug, // <- exclude slug to avoid ?slug=[slug] leakage
    ...routerQuery
  } = router.query;

  const isBrandsPath = (path) => path?.includes("/brands/");

  const isCurrentPageBrands = isBrandsPath(currentPath);

  const shouldExcludeQueries =
    ["/brands", "/deals", "/rewards"].some((path) => targetPath?.startsWith(path)) ||
    isBrandsPath(targetPath);

  const updatedQuery =
    isCurrentPageBrands || shouldExcludeQueries
      ? {}
      : {
          ...routerQuery,
          ...(typeof href === "object" && typeof href.query === "object" ? href.query : {}),
        };

  return (
    <Link
      {...props}
      href={{
        pathname: targetPath,
        query: updatedQuery,
      }}
      prefetch={false}
    />
  );
}
